import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import Button from '../atoms/button';

const propTypes = {
  open: PropTypes.bool.isRequired,
  dialogClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

const AlertTeamMembers = ({ open, dialogClose, message }) => (
  <Dialog
    className="custom-modal-dialog confirmation-modal-dialog"
    open={open}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent className="dialog-content">
      <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
    </DialogContent>
    <DialogActions className="dialog-actions">
      <Button danger onClick={dialogClose}>Ok</Button>
    </DialogActions>
  </Dialog>
);

AlertTeamMembers.propTypes = propTypes;
export default AlertTeamMembers;
